<template>

</template>

<script>
export default {
  name: "Payments"
}
</script>

<style scoped>

</style>